import type { ReactNode } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth-client";
import { buildSignInRedirectPath, buildSignUpRedirectPath } from "../lib/auth-routing";
import { useSeo } from "../lib/seo";

export function ProtectedFecDetailRoute({ children, committeeId }: { children: ReactNode; committeeId?: string }) {
  const { isLoaded, isSignedIn } = useAuth();
  const location = useLocation();
  useSeo({ kind: "fec-committee-detail", committeeId });

  if (!isLoaded) {
    return (
      <div className="page-grid">
        <section className="card detail-auth-gate" role="status" aria-live="polite">
          Loading account...
        </section>
      </div>
    );
  }

  if (isSignedIn) {
    return <>{children}</>;
  }

  const returnPath = `${location.pathname}${location.search}${location.hash}`;
  return (
    <div className="page-grid">
      <section className="card detail-auth-gate">
        <Link className="text-link" to="/members">Back to Members</Link>
        <div className="monitor-teaser detail-auth-teaser">
          <h1>See this outside group profile.</h1>
          <p>Sign in or create an account to review current-cycle spending, filings, and track this committee.</p>
          <div className="monitor-teaser__actions">
            <Link className="monitor-teaser__primary" to={buildSignInRedirectPath(returnPath)}>Sign in</Link>
            <Link className="monitor-teaser__secondary" to={buildSignUpRedirectPath(returnPath)}>Create account</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
